/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from "@vlinder-web/plugin-agent-service-react";
import {
  HeaderService,
  IHeaderMethods,
  SettingsService,
  ISettingsMethods,
  IStaticPageContentMethods,
  StaticPageContentService,
  ILoadingMethods,
  LoadingService,
  UserListsService,
  IUserListsMethods,
} from "./components";

export type CashierPaymentPageAgent = IHeaderMethods &
  IStaticPageContentMethods &
  ILoadingMethods &
  IUserListsMethods &
  ISettingsMethods

const getPlugins = () => {
  return [
    new HeaderService(),
    new StaticPageContentService(),
    new LoadingService(),
    new UserListsService(),
    new SettingsService()
  ];
};

export const getAgent = () => {
  return createAgent<CashierPaymentPageAgent>({
    plugins: getPlugins(),
  });
};
